<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container class="mt-5" fluid>
      <v-form 
       ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="updatePostage">
        <div class="registration-section">
          <div class="main-register">
            <div class="registration-heading">
              <h2>{{ $t('animal.conceptionInfo.postageEdit') }}</h2>
            </div>
            <div class="registration-btn">
              <v-btn
                width="146"
                class="mr-2"
                color="primary"
                outlined
                exact
                :to="{ name: 'SemenAuto' }"
                >{{ $t('cancel') }}</v-btn
              >
              <v-btn type="submit" width="146" color="primary">{{ $t('submit') }}</v-btn>
            </div>
          </div>
          <v-card class="px-5 mt-5">
            <div class="animal-from">
              <v-row class="pa-5">
                <v-col cols="12"></v-col>
                <v-col lg="4" md="6" sm="6" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{ $t('animal.conceptionInfo.postageCustomerName') }} </label>
                    </div>
                    <v-text-field
                      type="text"
                      v-model="postageAdd.customerName"
                      :placeholder="$t('animal.conceptionInfo.postageCustomerName')"
                      outlined
                      dense
                      :rules="semenRules.customerName"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="6" sm="6" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{ $t('animal.conceptionInfo.customerAddress') }}</label>
                    </div>
                    <v-text-field
                      type="text"
                      v-model="postageAdd.customerAddress"
                      :placeholder=" $t('animal.conceptionInfo.customerAddress')"
                      outlined
                      dense
                       :rules="semenRules.customerAddress"
                    ></v-text-field>
                  </div>
                </v-col>
                <!-- <v-col cols="3" class="display-none"></v-col> -->
                <v-col lg="4" md="6" sm="6" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{ $t('postID') }}</label>
                    </div>
                    <v-text-field
                      type="text"
                      v-model="postageAdd.postId"
                      placeholder="PST12345"
                      outlined
                      dense
                      :rules="semenRules.postId"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="6" sm="6" xs="6">
                  <div class="form-group">
                    <label for="text">{{  $t('orderdate') }}</label>
                    <v-menu
                      v-model="samplemenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="postageAdd.orderDate"
                          append-icon="mdi-calendar"
                          outlined
                          dense
                          placeholder="02/12/2020"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="semenRules.orderDate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="postageAdd.orderDate"
                        @input="samplemenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <v-col lg="4" md="6" sm="6" xs="6">
                  <div class="form-group">
                    <label for="text"> {{ $t('postageDate') }} </label>
                    <v-menu
                      v-model="samplemenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="postageAdd.postageDate"
                          append-icon="mdi-calendar"
                          outlined
                          dense
                          placeholder="02/12/2020"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                           :rules="semenRules.postageDate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="postageAdd.postageDate"
                        @input="samplemenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <v-col lg="4" md="6" sm="6" xs="6">
                  <div class="form-group">
                    <label for="text"> {{ $t('animal.conceptionInfo.deliveryDate') }}</label>
                    <v-menu
                      v-model="samplemenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="postageAdd.deliveryDate"
                          append-icon="mdi-calendar"
                          outlined
                          dense
                          placeholder="02/12/2020"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                             :rules="semenRules.deliveryDate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="postageAdd.deliveryDate"
                        @input="samplemenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <!-- <v-col cols="8"></v-col> -->
                <v-col cols="12"></v-col>
              </v-row>
            </div>
          </v-card>
          <div class="registration-btn bottom-btn">
            <v-btn
              width="146"
              class="mr-2"
              outlined
              color="primary"
              exact
              :to="{ name: 'SemenAuto' }"
              >{{ $t('cancel') }}</v-btn
            >
            <v-btn width="146" type="submit" color="primary">{{ $t('submit') }}</v-btn>
          </div>
        </div>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import SemenService from "@/_services/SemenService";
// import GenoService from "@/_services/GenoService";
import { semenRules } from "@/validations/SemenFormRules.js";
export default {
  async mounted() {
    await this.getItem();
  },
  data() {
    return {
      semenRules,
        valid:true,
        perUni:[
            "meter"
        ],
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('semenAutomation'),
          disabled: false,
          exact: true,
          link: true,
          to: { name: "SemenAuto" },
        },
        {
          text: this.$t('postage'),
          disabled: true,
        },
      ],
      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      postageAdd: {},
    };
  },
  methods: {
    getItem() {
      SemenService.getSinglepost(this.$route.params.id).then(async (data) => {
        console.log(data);
        this.postageAdd = data.sAutomationPostage;
        this.postageAdd.sireId = data.sAutomationPostage.animalNumber;
      });
    },
    updatePostage() {
       if (!this.$refs.form.validate()) return;
      this.startLoading();
      console.log("sere", this.postageAdd);
      SemenService.updatePostage(this.postageAdd)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.$notify({
              title: "Postage Automation is Updated",
              text: res.message,
              type: "success",
            });
          } else {
            this.$notify({
              title: "Postage Automation Not Updated",
              text: res.message,
              type: "error",
            });
          }
          this.stopLoading();
        })
        .catch((error) => {
          if (error.status == 422) {
            error.data.message.errors.forEach((err) => {
              console.log(err.param + " -- " + err.msg);
              this.errors[err.param] = err.msg;
            });
            console.log(this.errors);
          }
          this.stopLoading();
        });
    },
  },
  mixins: [loading],
};
</script>


<style lang="scss">
.registration-section .main-register {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.registration-heading {
  display: flex;
  align-items: center;
}
.registration-section .registration-heading h2 {
  /* color:#6A7784; */
  /* font-size: 20px; */
  font-family: Poppins-Medium;
}
.registration-section .registration-heading span {
  width: 1px;
  height: 30px;
  /* background: #6A7784; */
  margin: 0px 15px;
}
.registration-section .registration-heading p {
  /* color: #97A8B8; */
  font-size: 20px;
  font-family: Poppins-Medium;
}
.registration-btn {
  display: flex;
  align-items: center;
}
.registration-btn.bottom-btn {
  margin: 30px 22px 0px 0px;
  justify-content: flex-end;
  padding: 24px 15px;
  border-top: 1px solid #dae1ec;
  width: 100%;
}

.animal-from.margin-cell-3 {
  margin-top: 20px;
}
.animal-from {
  display: inline;
}
.animal-from label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.animal-from .form-control {
  display: block;
  width: 100%;
  height: 50px;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.animal-from .form-control:focus-visible,
.form-control-2:focus-visible {
  outline: none;
}
.animal-from .form-control::placeholder {
  font-size: 14px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.animal-from .form-control-2 {
  display: block;
  width: 100%;
  height: 50px;
  padding: 1px 20px;
  line-height: 1.5;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
  background-position: calc(100% - 1.2rem) center !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  /* background-image: url(../img/drop2.png); */
  background-repeat: no-repeat;
  font-size: 14px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.cell-2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cell-2 h2 {
  font-size: 14px;
  color: #70a4d3;
  font-family: Poppins-Medium;
  font-weight: 100;
}
.form-group {
  margin-top: -20px;
}
@media only screen and (max-width: 1200px) {
  .animal-from label {
    font-size: 12px;
  }
  .drag-text h3 {
    font-size: 10px;
  }
  .display-none {
    display: none;
  }
}
@media only screen and (max-width: 575px) {
  .registration-section .main-register {
    flex-direction: column;
  }
  .registration-btn {
    margin-top: 20px;
  }
}
</style>